import "./styles.scss";

import { Box, Container, Grid, Paper, Skeleton } from "@mui/material";

export const DashboardSubjectSkeletonRow = () => {
  const subjectCards = Array.from({ length: 7 });

  return (
    <Box className="dashboard-subject-skeleton-row">
      {subjectCards.map((_, idx) => (
        <Skeleton
          key={`dashboard-subject-skeleton-${idx}`}
          variant="rounded"
          width={160}
          height={200}
        />
      ))}
    </Box>
  );
};

export const DashboardListSkeletonGrid = ({ count = 6 }) => {
  return Array.from({ length: count }).map((_, idx) => (
    <Grid item xs={12} md={4} key={`dashboard-list-skeleton-${idx}`}>
      <Box className="dashboard-list-skeleton-card">
        <Box className="dashboard-list-skeleton-card__header">
          <Box className="dashboard-list-skeleton-card__author">
            <Skeleton variant="circular" width={30} height={30} />
            <Box className="dashboard-list-skeleton-card__author-copy">
              <Skeleton variant="text" width={112} height={18} />
              <Skeleton variant="text" width={58} height={14} />
            </Box>
          </Box>
          <Box className="dashboard-list-skeleton-card__menu">
            <Skeleton variant="circular" width={24} height={24} />
            <Skeleton variant="circular" width={24} height={24} />
          </Box>
        </Box>

        <Skeleton variant="rounded" className="dashboard-list-skeleton-card__media" />

        <Box className="dashboard-list-skeleton-card__body">
          <Skeleton variant="text" width="44%" height={32} />

          <Box className="dashboard-list-skeleton-card__chips">
            {Array.from({ length: 3 }).map((chip, chipIdx) => (
              <Skeleton
                key={`dashboard-list-skeleton-chip-${idx}-${chipIdx}`}
                variant="rounded"
                width={chipIdx === 0 ? 96 : chipIdx === 1 ? 118 : 132}
                height={36}
                sx={{ borderRadius: "62.4375rem" }}
              />
            ))}
          </Box>

          <Box className="dashboard-list-skeleton-card__footer">
            <Box className="dashboard-list-skeleton-card__footer-left">
              <Skeleton variant="circular" width={24} height={24} />
              <Skeleton variant="circular" width={24} height={24} />
              <Skeleton variant="circular" width={24} height={24} />
            </Box>
            <Skeleton variant="circular" width={28} height={28} />
          </Box>
        </Box>
      </Box>
    </Grid>
  ));
};

const DashboardListsPageSkeleton = () => {
  return (
    <div className="new-dashboard-container">
      <Container
        maxWidth={false}
        className="sticky-container"
        sx={{ mb: 10, px: { xs: 2, sm: 3, md: 4 } }}
      >
        <Grid container spacing={2} columns={24} className="mt-4">
          <Grid item xs={24}>
            <Grid container spacing={2} className="lists-main-content">
              <div className="lists-filter-row">
                <Paper
                  elevation={0}
                  sx={{
                    borderRadius: "62.4375rem",
                    backgroundColor: "transparent",
                    ["@media (max-width: 48rem)"]: { width: "100%" },
                  }}
                >
                  <Box className="lists-view-toggle dashboard-lists-tabs-skeleton">
                    <Skeleton variant="rounded" width={150} height={50} sx={{ borderRadius: "0.625rem" }} />
                    <Skeleton variant="rounded" width={190} height={50} sx={{ borderRadius: "0.625rem" }} />
                  </Box>
                </Paper>

                <Box className="lists-filter-actions dashboard-lists-actions-skeleton">
                  <Skeleton
                    variant="rounded"
                    className="dashboard-lists-subject-skeleton"
                  />
                  <Skeleton
                    variant="rounded"
                    className="dashboard-lists-create-skeleton"
                  />
                </Box>
              </div>

              <DashboardListSkeletonGrid />
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default DashboardListsPageSkeleton;
